<template>
    <form class="form booking-form" method="POST" action="/book" @submit.prevent="submit()">

        <section>

            <div class="form__field">
                <span class="description description--center">* Required fields</span>
            </div>

            <!-- Destination Input -->
            <div class="form__row show-next" v-if="!spot"  @click="form.errors.clear('city_id')">

                <label for="city_id">Destination*</label>

                <div class="form__field form__field--select ">

                    <select id="city_id"
                            name="city_id"
                            class="required"
                            :class="{'button-error' : form.errors.has('city_id') }"
                            v-model="form.city_id"
                            placeholder="City">
                        <option disabled :value="null">Where to?</option>
                        <option v-for="destination in destinations"
                                :key="`destination-opt-${destination.id}`"
                                :value="destination.id"
                                v-text="destination.title">
                        </option>
                    </select>

                    <span class="error" v-text="form.errors.city_id"></span>
                </div>

            </div>

            <!-- Guests Input -->
            <div class="form__row" @click="form.errors.clear('guests')">
                <label for="guests">Number of Guests*</label>

                <div class="form__field form__field--select">
                    <select id="guests"
                            name="guests"
                            class="required"
                            v-model="form.guests"
                            :class="{'button-error' : form.errors.has('guests') }"
                            placeholder="Number of Guests">

                        <option disabled :value="null">How many people?</option>
                        <option v-for="(opt, index) in guestOptions" :key="`guest-opt-${index}`"
                                :value="opt.label"
                                v-text="opt.label">
                        </option>
                    </select>

                    <span class="error" v-text="form.errors.guests"></span>
                </div>
            </div>

            <!-- Budget Input -->
            <div class="form__row" @click="form.errors.clear('budget')">
                <label for="budget">Budget*</label>
                <div class="form__field form__field--select">
                    <select id="budget"
                            name="budget"
                            v-model="form.budget"
                            class="required"
                            :class="{'button-error' : form.errors.has('budget') }"
                            placeholder="Budget">

                        <option disabled :value="null">What’s your budget per night?</option>
                        <option v-for="(opt, index) in budgetOptions" :key="`budget-opt-${index}`"
                                :value="opt.label"
                                v-text="opt.label">
                        </option>
                    </select>

                    <span class="error" v-text="form.errors.budget"></span>
                </div>
            </div>

        </section>

        <section>
            <!-- Dates -->
            <div class="form__date" @click="form.errors.clear('start_date'); form.errors.clear('end_date')">
                <label>Desired Dates*</label>
                <date-range-picker :class="{'button-error' : (form.errors.start_date || form.errors.end_date) }"
                                   @change="updateFormDates">
                </date-range-picker>
                <span class="error" v-if="(form.errors.start_date || form.errors.end_date)" v-text="form.errors.start_date"></span>
            </div>
        </section>

        <section>

            <!-- Looking to Dropdown -->
            <div class="form__row">
                <label for="looking_to">I'm looking to*</label>
                <div class="form__field form__field--select">
                    <select id="looking_to"
                            name="looking_to"
                            class="required"
                            @change="showTextAreas()"
                            :class="{'button-error' : form.errors.has('looking_to') }"
                            v-model="form.looking_to"
                            placeholder="I'm looking to">

                        <option disabled :value="null">I'm looking to</option>
                        <option v-for="(lookingOption, index) in lookingToOptions"
                                :key="`looking-to-opt-${index}`"
                                :value="lookingOption.label"
                                v-text="lookingOption.label">
                        </option>
                    </select>

                    <span class="error" v-text="form.errors.looking_to"></span>
                </div>
            </div>

            <!-- Input show Looking to at on Celebrate -->
            <div class="form__row hide-me looking_to_celebrating" @click="form.errors.clear('looking_to_celebrating')">
                <div class="form__field">
                    <textarea id="looking_to_celebrating"
                              :class="{'button-error' : form.errors.has('looking_to_celebrating') }"
                              name="looking_to_celebrating"
                              v-model="form.looking_to_celebrating"
                              placeholder="What are you celebrating?">
                    </textarea>

                    <span class="error" v-text="form.errors.looking_to_celebrating"></span>
                </div>
            </div>

            <!-- Input show Looking to at on Other -->
            <div class="form__row hide-me looking_to_other" @click="form.errors.clear('looking_to_other')">
                <div class="form__field">
                    <textarea id="looking_to_other"
                              :class="{'button-error' : form.errors.has('looking_to_other') }"
                              name="looking_to_other"
                              v-model="form.looking_to_other"
                              placeholder="">
                    </textarea>
                    <span class="error" v-text="form.errors.looking_to_other"></span>
                </div>
            </div>

            <!-- Comments -->
            <div class="form__row">
                <label for="comments">Anything to add?</label>
                <div class="form__field">
                    <textarea id="comments"
                              name="comments"
                              v-model="form.comments"
                              placeholder="Specific hotels or neighborhoods in mind? Room preferences? Bringing a pet?">
                    </textarea>
                </div>
            </div>
        </section>

        <section>

            <!-- User Credits -->
            <div v-if="userCredits > 0" class="form__field form__field--checkbox">
                <input type="checkbox"
                       id="use_credits"
                       v-model="form.use_credits"
                       name="use_credits"/>
                <label for="use_credits" style="cursor: pointer">
                    I want to apply my WT booking credit  (current balance <a href="/account/credits" target="_blank">${{ userCredits }}</a>)
                </label>
            </div>

            <!-- Submit Button -->
            <div class="form__button">
                <button type="submit"
                        :class="{'is-submitting' : form.isSubmitted, 'disabled' : isDisabled }"
                        class="button js-form-submit booking-submit booking-check-submit">
                    {{ form.isSubmitted ? 'Submitting' : 'Submit Request' }}
                    <svg class="arrow-right-2">
                        <use xlink:href="#arrow-right-2"></use>
                    </svg>
                </button>
            </div>

        </section>

    </form>
</template>
<script>

import Form from "@/classes/Form"
import Alert from "@/classes/Alert"
import Helpers from "@/mixins/Helpers"
import DateRangePicker from "@/components/DateRangePicker"

export default {

    mixins: [Helpers],

    components: {
        DateRangePicker
    },

    props: {
        spot: {
            required: false,
            type: [Object, null],
            default: null,
        },
        city: {
            required: false,
            type: [Object, null],
            default: null,
        },
        destinations: {
            type: Array,
            required: true,
        },
        userCredits:{
            required: true,
            type: Number,
        },
    },

    data() {
        return {
            budgetOptions: [
                {label: '$200 - $300 average nightly rate'},
                {label: '$300 - $400 average nightly rate'},
                {label: '$400 - $500 average nightly rate'},
                {label: '$500+ average nightly rate'}
            ],
            guestOptions: [
                {label: '1'},
                {label: '2'},
                {label: '3'},
                {label: '4'},
                {label: '5'},
                {label: '6+'}
            ],
            lookingToOptions: [
                {label: 'Unwind & relax'},
                {label: 'Wine & dine'},
                {label: 'Celebrate'},
                {label: 'Explore'},
                {label: 'Party'},
                {label: 'Business travel'},
                {label: 'Other'},
            ],
            form: new Form({
                city_id: null,
                recommendation_id: this.spot ? this.spot.id : null,
                guests: null,
                budget: null,
                start_date: null,
                end_date: null,
                looking_to: null,
                looking_to_celebrating: '',
                looking_to_other: '',
                comments: '',
                use_credits: false
            }).dontClear()
        }
    },

    created() {
        if (this.city) {
            this.form.city_id = this.city.id
        }
    },

    methods: {

        submit() {
            this.form.post(`/book`)
                .then(response => {
                    this.redirectTo('/book/success')
                })
                .catch(response => {
                    Alert.error(response.message)
                })
        },

        updateFormDates(dates) {
            this.form.start_date = dates.start_date
            this.form.end_date = dates.end_date;
        },

        showTextAreas() {
            if (this.form.looking_to == 'Celebrate') {
                $('.hide-me.looking_to_celebrating').slideDown();
            } else {
                $('.hide-me.looking_to_celebrating').slideUp();
            }

            if (this.form.looking_to == 'Other') {
                $('.hide-me.looking_to_other').slideDown();
            } else {
                $('.hide-me.looking_to_other').slideUp();
            }
        }
    },

    computed:{
        isDisabled(){
            if(this.form.isSubmitted) return true;
            if(this.form.city_id == null) return true;
            if(this.form.guests == null) return true;
            if(this.form.budget == null) return true;
            if(this.form.start_date == null) return true;
            if(this.form.end_date == null) return true;
            if(this.form.looking_to == null) return true;
            return false;
        }
    }
}
</script>
